export default class WPXFormValue<T> {
  public valid: boolean = false
  public data: T
  protected classRef: (new () => T) | null

  constructor(classRef?: (new () => T)) {
    if (classRef) {
      this.classRef = classRef;
      this.data = new classRef()
    }
  }

  public resetData(): void {
    if (this.classRef) {
      this.data = new this.classRef();
    }
  }
}
